import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Fades in each .new-collection-item from the top as it enters view
 * Only works on screens above 760px width - displays normally on smaller screens
 * @param {Object} options - Configuration options
 * @param {number} options.duration - Animation duration (default: 0.8)
 * @param {string} options.ease - GSAP easing function (default: "power2.out")
 * @param {string} options.startOffset - Start trigger offset (default: "top 85%")
 * @param {number} options.minWidth - Minimum screen width for animation (default: 760)
 */
function createFadeInFromTopAnimation(options = {}) {
  const {
    duration = 0.8,
    ease = 'power2.out',
    startOffset = 'top 65%',
    minWidth = 760
  } = options;

  const cards = gsap.utils.toArray('.new-collection-item');

  if (cards.length === 0) return;

  cards.forEach(card => {
    if (window.innerWidth <= minWidth) {
      // Reset styles on small screens
      gsap.set(card, {
        opacity: 1,
        y: 0,
        clearProps: 'all'
      });
      return;
    }

    gsap.set(card, {
      opacity: 0,
      y: -100
    });

    ScrollTrigger.create({
      //markers: true,
      trigger: card,
      start: startOffset,
      toggleActions: 'play none none reverse',
      onEnter: () => {
        gsap.to(card, {
          opacity: 1,
          y: 0,
          duration: duration,
          ease: ease
        });
      },
      onLeaveBack: () => {
        // Optional: reset if scrolling back up
        gsap.to(card, {
          opacity: 0,
          y: 100,
          duration: duration * 0.6,
          ease: 'power1.inOut'
        });
      }
    });
  });
}

export {
  createFadeInFromTopAnimation
};
